import { Box} from '@chakra-ui/react';
import config from '../../../config/app-config';


const GeneralPageFooter = () => {
	const currentDate = new Date();
	const currentYear = currentDate.getFullYear();
  const { appVersionNumber } = config;

	return (
		<Box py={['1em', '1%']} textAlign='center' fontSize='0.7em'>
			<Box>© {currentYear} Launchdeck All Rights Reserved</Box> 
			<Box>Version number: v{appVersionNumber}</Box>
		</Box>
	);
};

export default GeneralPageFooter;
